/*--------------------------------------------*\
    WooCommerce Add To Cart Buttons
\*--------------------------------------------*/

(function ($) {
    function init_tooltips($context) {
        if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) {
            return;
        }

        $context.find('[data-bs-toggle="tooltip"]').each(function () {
            bootstrap.Tooltip.getOrCreateInstance(this);
        });
    }

    function apply_cart_fragments(fragments, cart_hash, $button) {
        if (!fragments) {
            return;
        }

        $.each(fragments, function (key, value) {
            $(key).replaceWith(value);
        });

        init_tooltips($(document));
        $(document.body).trigger('added_to_cart', [fragments, cart_hash, $button]);
    }

    function get_cart_url($button, $view_cart) {
        return $view_cart.attr('href') || $button.data('cart_url') || '';
    }

    function is_icon_button($button) {
        return $button.data('addToCartType') === 'icon' || $button.find('.fa-cart-shopping, .button-icon.cart').length > 0;
    }

    function set_icon_button_added($button) {
        $button
            .attr('aria-label', 'View cart')
            .attr('title', 'View cart')
            .attr('data-bs-title', 'View cart')
            .addClass('is-added-to-cart');

        $button.find('.sr-only').text('View cart');

        const $button_icon = $button.find('.button-icon.cart');
        if ($button_icon.length) {
            $button_icon
                .removeClass('cart')
                .addClass('added-to-cart')
                .html('<i class="fa-solid fa-check default-icon" aria-hidden="true"></i><i class="fa-solid fa-check hover-icon" aria-hidden="true"></i>');
            return;
        }

        $button.find('.fa-cart-shopping')
            .removeClass('fa-cart-shopping fa-regular')
            .addClass('fa-check fa-solid');
    }

    function set_text_button_added($button) {
        $button
            .text('Added to Cart')
            .attr('aria-label', 'View cart')
            .attr('title', 'View cart')
            .attr('data-bs-title', 'View cart')
            .addClass('is-added-to-cart');
    }

    $(document).ready(function () {
        init_tooltips($(document));
    });

    $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
        if (!$button || !$button.length) {
            return;
        }

        const $view_cart = $button.siblings('a.added_to_cart').first();
        const cart_url = get_cart_url($button, $view_cart);

        if (cart_url) {
            $button
                .attr('href', cart_url)
                .data('cart_url', cart_url)
                .removeClass('ajax_add_to_cart add_to_cart_button loading')
                .addClass('added');
        }

        $view_cart.remove();

        if (is_icon_button($button)) {
            set_icon_button_added($button);
        } else {
            set_text_button_added($button);
        }
    });

    $(document).on('click', '[data-cart-series-expand]', function () {
        const $button = $(this);
        const cart_item_key = $button.data('cart-item-key') || '';

        if (!cart_item_key || $button.prop('disabled')) {
            return;
        }

        $button.prop('disabled', true).addClass('loading');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'flutterbee_expand_cart_series_item',
                cart_item_key,
            },
            success: function (data) {
                apply_cart_fragments(data.fragments, data.cart_hash, $button);
                window.location.reload();
            },
            error: function (data) {
                $button.prop('disabled', false).removeClass('loading');
                window.alert(data.message || 'Error');
            },
        });
    });
})(jQuery);
